import React from 'react';
import { Modal } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { CREDIT_CONSUMPTION_ROWS } from 'utils/smartContent/creditConsumption';
import './InsufficientCreditsModal.css';

const DEFAULT_MESSAGE =
  "Vous ne disposez pas d'un nombre de crédits suffisant pour générer ce contenu.\nRetrouvez ci-dessous le détail de la consommation de crédits.";

export const InsufficientCreditsModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText,
  secondaryButtonText,
  rows = CREDIT_CONSUMPTION_ROWS,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      className="insufficient-credits-modal"
      backdrop
      keyboard
      centered
      zIndex={2000}
    >
      <div className="insufficient-credits-modal-content">
        <div className="insufficient-credits-modal-header">
          <h2 className="insufficient-credits-modal-title">
            {title || t('Crédits insuffisants')}
          </h2>
          <button
            type="button"
            className="insufficient-credits-modal-close-button"
            onClick={onClose}
            aria-label={t('Fermer')}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="#666666"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className="insufficient-credits-modal-body">
          <p className="insufficient-credits-modal-message">
            {message || t(DEFAULT_MESSAGE)}
          </p>

          <div className="insufficient-credits-table-wrap">
            <table className="insufficient-credits-table">
              <thead>
                <tr>
                  <th>{t('Fonctionnalité')}</th>
                  <th>{t('Consommation crédit')}</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.label}>
                    <td>{t(row.label)}</td>
                    <td>{row.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="insufficient-credits-modal-footer">
          <button
            type="button"
            className="insufficient-credits-modal-secondary-button"
            onClick={onClose}
          >
            {secondaryButtonText || t('Annuler')}
          </button>
          <button
            type="button"
            className="insufficient-credits-modal-confirm-button"
            onClick={onConfirm}
          >
            {confirmButtonText || t('Recharger des crédits')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default InsufficientCreditsModal;
